import React from 'react';
import { ArrowLeft } from 'lucide-react';

/**
 * PageHeader - Reusable page header component for Operations and Finance pages
 * Following the Finance pages pattern (e.g., EBITDADetail)
 * 
 * Props:
 * - flowMap: Optional React component to render between title/subtitle and the rest of the content
 */
const PageHeader = ({ 
  title, 
  period, 
  subtitle, 
  backLabel, 
  onBack, 
  language = 'pt',
  flowMap = null
}) => {
  return (
    <div className="mb-6">
      {onBack && (
        <button 
          onClick={onBack}
          className="flex items-center gap-2 text-sm mb-4 transition-colors hover:opacity-80 text-slate-500"
        >
          <ArrowLeft className="w-4 h-4" />
          {backLabel}
        </button>
      )}
      <div className="flex items-start justify-between">
        <div>
          <h1 
            className="text-[32px] leading-[40px] font-semibold tracking-[-0.3px] mb-2 text-primary"
            style={{ fontFamily: '"Source Serif 4", Georgia, serif' }}
          >
            {title} {period && `| ${period}`}
          </h1>
          {subtitle && (
            <p className="text-[14px] leading-[20px] text-slate-500">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {/* Flow Map - Appears below title and subtitle */}
      {flowMap && <div className="mt-4">{flowMap}</div>}
    </div>
  );
};

export default PageHeader;
